export default __webpack_public_path__ + "static/media/7-Pre-Listing-Traps _ Pitfalls.a12ec4c7.png";